import { ClassName, Dialog } from "@busybusy/webapp-react-ui";
import classNames from "classnames";
import ProDetailsItem from "components/foundation/details-item/ProDetailsItem/ProDetailsItem";
import { useOpenable } from "hooks";
import { t } from "i18next";
import IPosition from "types/Position";
import { equipmentInspectionsStatusString } from "utils/positionUtils";
import EquipmentInspectionsForm from "../forms/EquipmentInspectionsForm";

export interface IEquipmentInspectionsDetailProps {
    editable: boolean;
    position: IPosition;
    onUpdate: () => Promise<any>;
    className?: ClassName;
}

const EquipmentInspectionsDetail = (props: IEquipmentInspectionsDetailProps) => {
    const { position, onUpdate, editable, className } = props;

    const formDialog = useOpenable();

    function onSubmit() {
        formDialog.close();
        onUpdate();
    }

    const classes = classNames('equipment-inspections-detail', className);

    return (
        <>
            <ProDetailsItem
                title={t('Equipment Inspections')}
                onClick={formDialog.open}
                value={equipmentInspectionsStatusString(position)}
                hint={t('Allow the employee to perform routine and ad hoc inspections (All employees can complete pre- and post-operation inspections when performing clock actions).')}
                className={classes}
                disabled={!editable}
            />
            <Dialog
                position={'center'}
                isOpen={formDialog.isOpen}
                onClose={formDialog.close}
            >
                <EquipmentInspectionsForm positionId={position.id} onSubmit={onSubmit} currentSetting={position.equipmentInspections}/>
            </Dialog>
        </>
    )
}

export default EquipmentInspectionsDetail;